export type CampaignBreadcrumb = {
  label: string;
  href?: string;
};

export const getCampaignShellBreadcrumbs = (pathname: string): CampaignBreadcrumb[] => {
  if (pathname === '/api-keys') {
    return [{ label: 'Settings', href: '/settings' }, { label: 'API keys' }];
  }
  if (pathname === '/dashboard' || pathname.startsWith('/dashboard/')) {
    return [{ label: 'Dashboard' }];
  }

  if (pathname === '/contacts/import') {
    return [{ label: 'Audience' }, { label: 'Contacts', href: '/contacts' }, { label: 'Import' }];
  }

  if (pathname === '/contacts' || pathname.startsWith('/contacts/')) {
    return [
      { label: 'Audience' },
      { label: 'Contacts', href: pathname === '/contacts' ? undefined : '/contacts' },
    ];
  }

  if (pathname === '/custom-fields' || pathname.startsWith('/custom-fields/')) {
    return [{ label: 'Settings', href: '/settings' }, { label: 'Custom fields' }];
  }

  if (pathname === '/identity-management' || pathname.startsWith('/identity-management/')) {
    return [{ label: 'Settings', href: '/settings' }, { label: 'Users & roles' }];
  }

  if (pathname === '/settings/opt-in') {
    return [{ label: 'Settings', href: '/settings' }, { label: 'Double opt-in' }];
  }

  if (pathname === '/settings' || pathname.startsWith('/settings/')) {
    return [{ label: 'Settings' }];
  }

  if (pathname === '/lists') {
    return [{ label: 'Audience' }, { label: 'Lists' }];
  }

  if (pathname.startsWith('/lists/')) {
    return [{ label: 'Audience' }, { label: 'Lists', href: '/lists' }];
  }

  if (pathname === '/segments' || pathname.startsWith('/segments/')) {
    return [{ label: 'Audience' }, { label: 'Segments' }];
  }

  if (pathname.startsWith('/suppression')) {
    return [{ label: 'Audience' }, { label: 'Suppression' }];
  }

  if (pathname.match(/^\/campaigns\/[^/]+\/content\/?$/)) {
    return [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Edit content' }];
  }

  if (pathname.startsWith('/campaigns')) {
    return [{ label: 'Campaigns' }];
  }

  if (pathname === '/media-library' || pathname.startsWith('/media-library/')) {
    return [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Media library' }];
  }

  if (pathname === '/sends' || pathname.startsWith('/sends/')) {
    return [{ label: 'Campaigns', href: '/campaigns' }, { label: 'Sends' }];
  }

  if (pathname.match(/^\/reports\/campaigns\/[^/]+\/links\/?$/)) {
    return [
      { label: 'Reports', href: '/reports/overview' },
      { label: 'Overview', href: '/reports/overview' },
      { label: 'Campaign', href: pathname.replace(/\/links\/?$/, '') },
      { label: 'Links & heatmap' },
    ];
  }

  if (pathname.match(/^\/reports\/campaigns\/[^/]+\/deliverability\/?$/)) {
    return [
      { label: 'Reports', href: '/reports/overview' },
      { label: 'Overview', href: '/reports/overview' },
      { label: 'Campaign', href: pathname.replace(/\/deliverability\/?$/, '') },
      { label: 'Deliverability' },
    ];
  }

  if (pathname.match(/^\/reports\/campaigns\/[^/]+\/?$/)) {
    return [
      { label: 'Reports', href: '/reports/overview' },
      { label: 'Overview', href: '/reports/overview' },
      { label: 'Campaign' },
    ];
  }

  if (pathname === '/reports/deliverability' || pathname.startsWith('/reports/deliverability/')) {
    return [{ label: 'Reports', href: '/reports/overview' }, { label: 'Deliverability' }];
  }

  if (pathname === '/reports' || pathname.startsWith('/reports/')) {
    return [{ label: 'Reports' }, { label: 'Overview' }];
  }

  if (pathname === '/templates/create') {
    return [
      { label: 'Campaigns' },
      { label: 'Templates', href: '/templates' },
      { label: 'New template' },
    ];
  }

  if (pathname.match(/^\/templates\/edit\/[^/]+\/?$/)) {
    return [
      { label: 'Campaigns' },
      { label: 'Templates', href: '/templates' },
      { label: 'Edit template' },
    ];
  }

  if (pathname.startsWith('/templates')) {
    return [{ label: 'Campaigns' }, { label: 'Templates' }];
  }

  return [];
};
